import { render, staticRenderFns } from "./tabGroup.vue?vue&type=template&id=475924e0&scoped=true"
import script from "./tabGroup.vue?vue&type=script&lang=js"
export * from "./tabGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475924e0",
  null
  
)

export default component.exports